export default __webpack_public_path__ + "static/media/product-2.2db7bbd7.jpg";